<template>
  <v-container fluid class="salesreport-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row align="center" no-gutters>
            <v-col v-if="query.userid!=null" cols="12" md="3" class="d-flex justify-space-between justify-md-start">
                <div>
                  <v-avatar v-if="users.find(user=>user._id == query.userid)['userimage']!==''" size="40">
                    <img v-bind:src="users.find(user=>user._id == query.userid)['userimage']" alt="">
                  </v-avatar>
                  <v-avatar v-else color="warning" size="40">
                    <span class="white--text headline">{{ users.find(user=>user._id == query.userid)['username'][0].toUpperCase() }}</span>
                  </v-avatar>
                  <span style="margin-left:15px">{{ users.find(user=>user._id == query.userid)['username'] }}</span>
                </div>
            </v-col>
            <v-col cols="12" md="3" class="d-flex justify-space-between justify-md-start">
              <div>
                <div style="display: block; margin: 0;" v-if="query.townshipid!=null"><span><b>Township:</b> {{ townships.find(town=>town._id == query.townshipid)['townshipname'] }}</span></div> 
                <div style="display: block; margin: 0;" v-if="query.startdate!=null || query.enddate!=null"><b>Date Range:</b> {{ query.startdate }} - {{ query.enddate }}</div> 
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3" class="d-flex justify-space-between justify-md-end">
              <v-btn 
                color="success" 
                class="button-shadow mr-3"
                @click="findSalesReportDialog = true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="salesreports.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="salesreports-table"
              single-select
              item-key="_id"
              sort-by="salesreportname"
              :footer-props="footer"
              :headers="headers"
              :items="salesreports"
              :items-per-page="itemPerPage">
              <template v-slot:item.itemimage="{ item }">
                  <img v-bind:src="item.itemimage" alt="" width="60">
              </template>
              <template v-slot:item.amount="{ item }">
                {{ item.amount!==undefined ? (item.amount).toFixed(1) : '' }}
              </template>
              <template v-slot:item.quantity="{ item }">
                {{ item.quantity!==undefined ? (item.quantity).toFixed(1) : '' }}
              </template>
              <template v-slot:item.avgprice="{ item }">
                {{ item.avgprice!==undefined ? (item.avgprice).toFixed(1) : '' }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="findSalesReportDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Sales Report</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <!-- <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="users.filter(x=>x.userstatus=='Active').map(x => {
                            return {text: x.username, value: x._id};
                          })"
                  v-model="query.userid"
                  label="Sales Rep"
                  required
                ></v-select>
              </v-col> -->
              <!-- <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="townships.filter(x=>x.townshipstatus=='Active').map(x => {
                            return {text: x.townshipname, value: x._id};
                          })"
                  v-model="query.townshipid"
                  label="Township"
                  required
                ></v-select>
              </v-col> -->
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="query = {}"
          >
            Clear
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findSalesReportDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findSalesReport"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';



export default {
  name: 'SalesReportByItem',
  data() {
    return {
      headers: [
        { text: 'Image', value: 'itemimage' },
        { text: 'User', value: 'itemname' },
        { text: 'Qty', value: 'quantity' },
        { text: 'Avg Price', value: 'avgprice' },
        { text: 'Amount', value: 'amount' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      findSalesReportDialog: false,
      query: {},
      salesreports: [],
      menu_startdate: null,
      menu_enddate: null,
      offset: 0,
    }
  },
  computed: {
    ...mapState('SalesReport', ['isDeleting', 'isReceiving']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  created () {
    if(this.users.length==0) this.getUsersRequest();
    if(this.townships.length==0) this.getTownshipsRequest();
  },
  methods: {
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    ...mapActions('SalesReport', ["getSalesReportsByUser"]),
    async findSalesReport(){
      this.findSalesReportDialog = false;
      let results = await this.getSalesReportsByUser(this.query);
      console.log(results);
      this.salesreports = [];
      for(var i=0; i<results.length; i++){
        let result = results[i];
        if(result.userSales.length>0){
          this.salesreports.push({itemname: result.username, itemimage: result.userimage, userSales: result.userSales});
          for(var j=0; j<result.userSales.length; j++){
            let sales = result.userSales[j];
            this.salesreports.push({
              itemname: sales.itemname, 
              itemimage: sales.itemimage, 
              quantity: sales.quantity,
              avgprice: sales.avgprice,
              amount: sales.amount,
            })
          }
          this.salesreports.push({amount: result.userSales.reduce(function (last, json) {return last + json.amount;}, 0) });
        }
      }

      //this.salesreports.push({amount: this.salesreports.reduce(function (last, json) {return last + json.amount;}, 0) });
      console.log(this.salesreports);
    },
    getJson(){
      let json = this.salesreports.map(report=>{return {
        itemname: report.itemname, 
        quantity: report.quantity, 
        avgprice: report.avgprice ? report.avgprice.toFixed(1) : null, 
        amount: report.amount
      }});
      return json;
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-report-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    saveExcel() {
      let item = Object.assign({}, this.query);
      item.salesreports = this.salesreports;
      this.$router.push({ name: 'SalesReportPrint', params: item })
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
